import { Component, Input } from '@angular/core';
import { IBanner, IFaqResponse, IProductFaq } from '@interfaces';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';

@Component({
  selector: 'bz-faq',
  templateUrl: './bz-faq.component.html',
  styleUrls: ['./bz-faq.component.sass']
})
export class BzFaqComponent {
  @Input() public heading: string = '';
  @Input() public text: string = '';
  @Input() public footer: string = '';
  @Input() public faqs: IFaqResponse[] | IProductFaq[] = [];
  @Input() public setMobileWhiteBackground: boolean = true;
  @Input() public setDesktopWhiteBackground: boolean = false;
  @Input() public banner: IBanner | null = null;

  public bannerImages: string;

  constructor(
    private readonly restUrlService: RestUrlService
  ) {
    this.bannerImages = this.restUrlService.getUrl(TypeUrl.img) + '/ad/';
  }

  toggleFaqAnswer(faqIndex: number, event: string): void {
    const blockId: string = `faq-answer-${faqIndex}`;
    const textContainer: HTMLElement = document.getElementById(blockId);
    if (textContainer) {
      if (event === 'open') {
        textContainer.style.display = 'block';
        const openIconId: string = `toggle-open-${faqIndex}`;
        document.getElementById(openIconId).style.display = 'none';
        const hideIconId: string = `toggle-hide-${faqIndex}`;
        document.getElementById(hideIconId).style.display = 'block';
      }
      if (event === 'hide') {
        textContainer.style.display = 'none';
        const openIconId: string = `toggle-open-${faqIndex}`;
        document.getElementById(openIconId).style.display = 'block';
        const hideIconId: string = `toggle-hide-${faqIndex}`;
        document.getElementById(hideIconId).style.display = 'none';
      }
    }
  }
}
